import { createSlice, createEntityAdapter } from '@reduxjs/toolkit'

import { sortByDateAndKey } from 'utils/date'
import { store } from '../'

export const adapter = createEntityAdapter({
  selectId: (item) => item?._id,
  sortComparer: false
})

export const slice = createSlice({
  name: 'adminPerformance',
  initialState: adapter.getInitialState(),
  reducers: {
    setAdminPerformanceDeal: (state, { payload }) => adapter.setOne(state, payload),
    removeAdminPerformanceDeal: (state, { payload }) => adapter.removeOne(state, payload),
    setAdminPerformanceDeals: (state, { payload }) => adapter.setAll(state, payload),
    adminPerformanceDealsRemoveAll: (state, { payload }) => adapter.removeAll(state, payload)
  }
})

export const { setAdminPerformanceDeal, removeAdminPerformanceDeal, setAdminPerformanceDeals, adminPerformanceDealsRemoveAll } = slice.actions

export default slice.reducer

const getItems = (items) => {
  try {
    return Object.values(items?.entities)
  } catch (e) {
    return []
  }
}

export const setAdminPerformance = () => {
  const state = store.getState()
  const { adminDeals } = state
  const deals = getItems(adminDeals)

  return (dispatch) => {
    const filtered = deals?.length
      ? deals.filter((i) => i?.dealStatus === 'done' || i?.dealStatus === 'exited')
      : []

    if (filtered?.length) dispatch(setAdminPerformanceDeals(sortByDateAndKey(filtered, 'exitDate', 'closingDate')))
  }
}
